import { c as _c } from "react/compiler-runtime";
import './recent-activity-item.scss';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@sola/ark-core/utils/helpers.ts';
export type RecentActivityItemTrackerProps = {
  steps: string[];
  activeStepIndex: number;
};
export const RecentActivityItemTracker: React.FC<RecentActivityItemTrackerProps> = t0 => {
  const $ = _c(21);
  const {
    steps,
    activeStepIndex
  } = t0;
  const {
    t
  } = useTranslation("my");
  if (activeStepIndex < 0) {
    return null;
  }
  let t1;
  if ($[0] !== t) {
    t1 = t("recentActivity.stepsTracker");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== activeStepIndex || $[3] !== steps) {
    let t3;
    if ($[5] !== activeStepIndex || $[6] !== steps.length) {
      t3 = (step, index) => {
        const isCompleted = index < activeStepIndex;
        const isActive = index === activeStepIndex;
        const isFuture = index > activeStepIndex;
        const isLastStep = index === steps.length - 1;
        return <React.Fragment key={step}><span className={cn("RecentActivityItem__tracker-dot shrink-0 relative", {
            "RecentActivityItem__tracker-dot--completed": isCompleted,
            "RecentActivityItem__tracker-dot--active": isActive,
            "RecentActivityItem__tracker-dot--future": isFuture
          })} aria-label={step} {...isActive ? {
            "aria-current": "step"
          } : {}} />{!isLastStep && <span className={cn("RecentActivityItem__tracker-line flex-1", {
            "RecentActivityItem__tracker-line--completed": isCompleted,
            "RecentActivityItem__tracker-line--future": index >= activeStepIndex
          })} />}</React.Fragment>;
      };
      $[5] = activeStepIndex;
      $[6] = steps.length;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    t2 = steps.map(t3);
    $[2] = activeStepIndex;
    $[3] = steps;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[8] !== t1 || $[9] !== t2) {
    t3 = <div className="RecentActivityItem__tracker-track mt-snug-xl flex w-full" role="group" aria-label={t1}>{t2}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== activeStepIndex || $[12] !== steps) {
    let t5;
    if ($[14] !== activeStepIndex) {
      t5 = (step_0, index_0) => {
        const isFuture_0 = index_0 > activeStepIndex;
        return <span key={step_0} className={cn("RecentActivityItem__tracker-label flex label-md", {
          "label-moderate": !isFuture_0,
          "RecentActivityItem__tracker-label--future label-mild": isFuture_0
        })}>{step_0}</span>;
      };
      $[14] = activeStepIndex;
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    t4 = steps.map(t5);
    $[11] = activeStepIndex;
    $[12] = steps;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[16] !== t4) {
    t5 = <div className="grid grid-cols-3 mt-comfy-xs">{t4}</div>;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t3 || $[19] !== t5) {
    t6 = <div className="RecentActivityItem__tracker w-full">{t3}{t5}</div>;
    $[18] = t3;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
};